<template>
    <div class="sidebar">
		<ul>
			<li v-for="(item,index) in menuList" :key="index" :class='flag==index?"current":""' @click="changeTab(1,item,index)">
				<template>
					<img :src='flag==index?item.src:item.icon'>
					<span slot="title">{{ item.name }}</span>
				</template>
				
				<div v-if="item.children && item.children.length && flag == 3">
					<div v-for="(obj,idx) in item.children" :key="idx" :class='itemFlag==idx?"item-active":""' @click="changeTab(2,obj,idx)" class="menu-item">{{ obj.name }}</div>
				</div>
			</li>
		</ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
			flag:0,
			itemFlag:0,
            menuList: [
				{name:"我的订单",url:"./order-list", icon:require("@/assets/img/my_order.png"),    src:require("@/assets/img/my_order_active.png")},
				{name:"立即下单",url:"./place-order",icon:require("@/assets/img/place_order.png"), src:require("@/assets/img/place_order_active.png")},
				{name:"充值优惠",url:"./recharge",   icon:require("@/assets/img/charge.png"),      src:require("@/assets/img/charge_active.png")},
				{
					name:"个人中心",
					icon:require("@/assets/img/person.png"),
                    src:require("@/assets/img/person_active.png"),
                    // url:"./my-balance",
					children:[
						{name:"我的余额",url:"./my-balance"},
						{name:"我的消息",url:"./my-news"},
						{name:"通知开关",url:"./notice-switch"},
						{name:"个人资料",url:"./personal-data"},
					]
				},
			],
        };
    },
    
    methods:{
        changeTab(flag,item,index){
            if(flag == "1"){
                this.flag = index;
            }
            else{
                this.itemFlag = index;
            }
            if(item.url!="./place-order"){//去掉下单页面缓存信息
                sessionStorage.removeItem("flag");
                sessionStorage.removeItem("caseFlag");
                sessionStorage.removeItem("placeOrderId");
            }
            this.$router.push({
                path:item.url
            })
        }
    },
	
	watch: {
	    $route(val) {
			if(val.path == "/my-balance"){
				this.itemFlag = 0
			}
			else if(val.path == "/my-news"){
				this.itemFlag = 1
			}
			else if(val.path == "/notice-switch"){
				this.itemFlag = 2
			}
			else if(val.path == "/personal-data"){
				this.itemFlag = 3
			}
	    }
	}
};
</script>

<style lang="scss" scoped>
.sidebar {
	max-width: 240px;
    position: absolute;
	left: 0;
    top: 92px;
    bottom: 0;
    background: #fff;
    box-shadow: 1px 13px 7px 1px rgba(0,0,0,.06);
	ul{
		padding-top: 40px;
		width: 100%;
		height: 100%;
		padding-left: 12px;
		box-sizing: border-box;
		li{
			cursor: pointer;
			// display: flex;
			// align-items: center;
			// justify-content: center;
			width: 100%;
			height: 44px;
			line-height: 44px;
			margin-bottom: 30px;
			text-align: center;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #595959;
			img{
				width: 17px;
				height: 16px;
				vertical-align: middle;
                margin-right: 18px;
			}
			span{
				vertical-align: middle;
			}
			.menu-item{
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #999999;
			}
			.item-active{
				color: #FF8D1B;
			}
		}
		.current{
			width: 228px;
			height: 44px;
			background: rgba(253, 133, 13, 0.1);
			border-radius: 22px 0px 0px 22px;
			color: #FD850D;
		}
	}
    
}

</style>
